export const UPDATE_LOGIN_FORM = 'LOGIN.UPDATE_LOGIN_FORM'
export const DISPLAY_ERROR_MESSAGE = 'LOGIN.DISPLAY_ERROR_MESSAGE'

export function displayErrorMsg (msg) {
  return {
    type: DISPLAY_ERROR_MESSAGE,
    payload: msg
  }
}

export function showError (msg) {
  return (dispatch, getState) => {
    dispatch(displayErrorMsg(msg))
  }
}

const ACTION_HANDLERS = {
  [DISPLAY_ERROR_MESSAGE]: (state, action) => {
    return ({ ...state, errorMsg: action.payload })
  }
}

const initialState = {
  errorMsg: null
}

export default function loginReducer (state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type]

  return handler ? handler(state, action) : state
}



// WEBPACK FOOTER //
// ./src/routes/Login/modules/login.js